import { useMemo } from 'react';
import { formatPrice } from '../../../utils/formatters';
import { useDeviceType } from '@cian/ui-kit';

interface IParams {
  startPrice?: number;
  endPrice?: number;
}

export const useProjectPrice = ({ startPrice, endPrice }: IParams) => {
  const device = useDeviceType();

  return useMemo(() => {
    let result = '';

    if (startPrice) {
      result += `от ${formatPrice(startPrice)}`;
    }

    if (endPrice && device === 'desktop') {
      result += ` до ${formatPrice(endPrice)}`;
    }

    return result.trim() || undefined;
  }, [startPrice, endPrice, device]);
};
